export default __webpack_public_path__ + "static/media/29.7g30mmn.b07796dd.jpeg";